import React from 'react';
import * as S from './styles';
import Chat from 'components/Icons/Chat';
import PencilLIA from 'components/Icons/PincelLIA';
import ShapeLIA from 'components/Icons/ShapeLIA';
import DocumentSignature from 'components/Icons/DocumentSignature';
import GlobeLIA from 'components/Icons/GlobeLIA';
import { KenloLiaIcon } from 'components/Icons';
import { InvoiceStatus } from 'components/InvoiceStatus';
import { theme } from 'styles/theme';

interface ICard {
  name: string | undefined;
  status?: 'baixo' | 'medio' | 'alto' | 'médio' | 'novo cliente';
  broker?: string;
  date?: string;
  value?: string;
  type?: 'atendimento' | 'editor' | 'motion' | 'blog' | 'pages';
  clientName?: string;
  secondaryText?: string;
  actionType?: 'descricao' | 'foto' | 'animacao' | 'post' | 'landing';
}

const getIcon = (type: string | undefined) => {
  const iconColor = '#404040';
  switch (type) {
    case 'atendimento':
      return <Chat color={iconColor} />;
    case 'editor':
      return <PencilLIA color={iconColor} />;
    case 'motion':
      return <ShapeLIA color={iconColor} />;
    case 'blog':
      return <DocumentSignature color={iconColor} />;
    case 'pages':
      return <GlobeLIA color={iconColor} />;
    default:
      return <Chat color={iconColor} />;
  }
};



const CardDrawer = ({ broker, value, type, clientName, secondaryText, actionType }: ICard) => {
  const icon = getIcon(type);

  return (
    <S.CardContent>
      <S.IconWrapper>
        {icon}
      </S.IconWrapper>
      <S.TextContent>
      <S.SecondaryText>
          {secondaryText +   (broker ? " para "+ broker : "")}
        </S.SecondaryText>
        <S.MainText>
          {actionType ?? clientName}
        </S.MainText>
      </S.TextContent>
      <InvoiceStatus
        status={"venda"}
        text={Math.abs(Number(value || 0))}
        icon={<KenloLiaIcon size={16}/>}
        colortText={
        theme.colors.neutral.neutral120 
        }
        fontWeight="500"
      />
    </S.CardContent>
  );
};

export default CardDrawer;

